{
  "App.name": "ChimeDeck",
  "Common.loadingLabel": "Loading…",
  "Common.errorGeneric": "Something went wrong. Please try again.",
  "Common.errorBoundaryFallback": "Something went wrong. Please reload.",
  "Common.confirmDelete": "Are you sure? This cannot be undone.",
  "Common.confirmButton": "Confirm",
  "Common.cancelButton": "Cancel",
  "Common.closeButton": "Close",
  "Common.emptyState": "Nothing here yet",
  "Common.ariaCloseModal": "Close modal",
  "Common.ariaOpenMenu": "Open menu",
  "Common.ariaCloseMenu": "Close menu",
  "Common.dismissNotification": "Dismiss notification",
  "Common.toastRegionAriaLabel": "Notifications",
  "Common.avatarAlt": "Avatar",
  "Common.switchToLightMode": "Switch to light mode",
  "Common.switchToDarkMode": "Switch to dark mode",
  "CommandPalette.ariaLabel": "Search",
  "CommandPalette.inputAriaLabel": "Search",
  "CommandPalette.scopeTabsAriaLabel": "Search scope",
  "CommandPalette.allScopeLabel": "All",
  "CommandPalette.boardScopeLabel": "Boards",
  "CommandPalette.cardScopeLabel": "Cards",
  "CommandPalette.allScopePlaceholder": "Search boards and cards…",
  "CommandPalette.boardScopePlaceholder": "Search boards…",
  "CommandPalette.cardScopePlaceholder": "Search cards…",
  "CommandPalette.allScopeEmpty": "No results found.",
  "CommandPalette.boardScopeEmpty": "No boards found.",
  "CommandPalette.cardScopeEmpty": "No cards found.",
  "CommandPalette.tooShort": "Type at least 2 characters to search.",
  "CommandPalette.searching": "Searching…",
  "CommandPalette.error": "Search failed. Please try again.",
  "CommandPalette.boardsHeader": "Boards",
  "CommandPalette.cardsHeader": "Cards",
  "CommandPalette.footerNavigate": "navigate",
  "CommandPalette.footerOpen": "open",
  "CommandPalette.footerEscPrefix": "Press",
  "CommandPalette.footerEscClose": "to close",
  "Sidebar.searchLabel": "Search",
  "Sidebar.searchAriaLabel": "Search (⌘K)",
  "Sidebar.pluginDocsLabel": "Plugin Docs",
  "Sidebar.mcpDocsLabel": "MCP Docs",
  "Sidebar.inviteExternalUser": "Invite External User",
  "Sidebar.expandAriaLabel": "Expand sidebar",
  "Sidebar.collapseAriaLabel": "Collapse sidebar",
  "Sidebar.guestBadge": "guest",
  "Sidebar.ariaNavLabel": "Main navigation",
  "Layout.sidebarAriaLabel": "Main navigation",
  "Layout.topbarAriaLabel": "Top navigation",
  "Layout.skipToContent": "Skip to main content",
  "Layout.openSidebarAriaLabel": "Open sidebar",
  "Layout.mobileDrawerAriaLabel": "Navigation",
  "Sidebar.administrationSection": "Administration",
  "Sidebar.pluginsLabel": "Plugins"
}
